import type { BoggleChallengeBoardDistributionDefinition } from '~/boggle/config/boardDistributions/boardDistributionDefinition'
import type { BoggleResolvedChallengeBoardDistribution } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBoardDistributionDisplayFromDefinition } from '~/boggle/config/boardDistributions/formatResolvedBoardDistributionDisplay'

export const standardBoardDistributionDefinition: BoggleChallengeBoardDistributionDefinition = {
  description: 'Default spawn frequencies with no letter modifier',
  id: 'standard',
  name: 'Standard letter weights',
  parameterDefinitions: {},
  selectionWeight: 4,
  shortLabel: 'Standard',
}

export function resolveStandardBoardDistribution(
  family: BoggleChallengeBoardDistributionDefinition,
  rngState: number,
): {
  mod: BoggleResolvedChallengeBoardDistribution
  rngState: number
} {
  const parameters = {}
  const display = formatResolvedBoardDistributionDisplayFromDefinition(family, parameters)

  return {
    mod: {
      description: display.description,
      effects: [],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [],
      parameters,
      shortLabel: display.shortLabel,
    },
    rngState,
  }
}
